import { createAction, props } from '@ngrx/store';
import { ContractDto, InsurerDto, RefLanguageDto } from 'src/app/api/models';

export const loadContract = createAction(
  '[Contract] Load contract',
  props<{
    InsurerId?: string;
    CardNumber?: string;
    SiteId?: number;
    Language?: RefLanguageDto;
    InsurerQuestionnaireId?: number;
  }>()
);

export const loadContractSuccess = createAction(
  '[Contract] Load contract Success',
  props<{ data: ContractDto }>()
);

export const loadContractFailure = createAction(
  '[Contract] Load contract Failure',
  props<{ error: any }>()
);

export const submitCardId_S4 = createAction(
  '[Contract] Submit S4 card id',
  props<{ cardNumber: string, insurer: InsurerDto, siteId: number, hospitalNo: string, language: RefLanguageDto, urls4: string }>()
);

export const submitCardId_S4Success = createAction(
  '[Contract] Submit S4 card id success'
);

export const submitCardId_S4Failure = createAction(
  '[Contract] Submit S4 card id failure',
  props<{ error: any }>()
);

export const submitCardId = createAction(
  '[Contract] Submit card id',
  props<{ cardNumber: string, insurer: InsurerDto, siteId: number, hospitalNo: string, language: RefLanguageDto, insurerQuestionnaireId: number }>()
);

export const submitCardIdSuccess = createAction(
  '[Contract] Submit card id success',
  props<{ cardid: string }>()

);

export const submitCardIdFailure = createAction(
  '[Contract] Submit card id failure',
  props<{ error: any }>()
);
